import { render, staticRenderFns } from "./ParentCategories.vue?vue&type=template&id=7b21cbfc&scoped=true"
import script from "./ParentCategories.vue?vue&type=script&lang=js"
export * from "./ParentCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21cbfc",
  null
  
)

export default component.exports